export default __webpack_public_path__ + "static/media/calculator.31d162ea.png";